
const digest = '241878b47ae8c3dd3a543cc7ace2455b746c08bf53df5fa387506dbf1dad2cd7';
const classes = {"list":"_list_a50q0_1","editActive":"_editActive_a50q0_26","item":"_item_a50q0_32","header":"_header_a50q0_39","date":"_date_a50q0_44","doctorsName":"_doctorsName_a50q0_48","content":"_content_a50q0_55","text":"_text_a50q0_59","diagnose":"_diagnose_a50q0_67","mainContent":"_mainContent_a50q0_74","careClaims":"_careClaims_a50q0_77","careClaimsLabel":"_careClaimsLabel_a50q0_83","controls":"_controls_a50q0_87","print":"_print_a50q0_93","history":"_history_a50q0_104","edit":"_edit_a50q0_26","attachment":"_attachment_a50q0_127","link":"_link_a50q0_127"};
const css = `._list_a50q0_1 {
  overflow-y: scroll;
  flex-grow: 1;
  -ms-overflow-style: auto;
  scrollbar-width: 3px;
}
._list_a50q0_1::-webkit-scrollbar {
  display: block;
}
._list_a50q0_1::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  padding: 2px;
}
._list_a50q0_1::-webkit-scrollbar-track {
  background: #f1f1f1;
}
._list_a50q0_1::-webkit-scrollbar-thumb {
  background: #3e3f42;
  border-radius: 4px;
}
._list_a50q0_1::-webkit-scrollbar-thumb:hover {
  background: #3e3f42;
  border-radius: 4px;
}
._list_a50q0_1 ._editActive_a50q0_26 {
  background-color: #f2f4f7;
  padding-left: 15px;
  border-left: 3px solid #1d65d8;
}

._item_a50q0_32 {
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #eaedf3;
  padding-bottom: 16px;
  padding-top: 16px;
}
._item_a50q0_32 ._header_a50q0_39 {
  display: flex;
  flex-direction: row;
  gap: 15px;
}
._item_a50q0_32 ._header_a50q0_39 ._date_a50q0_44 {
  font-size: 14px;
  color: #000000;
}
._item_a50q0_32 ._header_a50q0_39 ._doctorsName_a50q0_48 {
  font-size: 14px;
  color: #000000;
}
._item_a50q0_32 ._header_a50q0_39 ._doctorsName_a50q0_48 span {
  color: #9ea0a5;
}
._item_a50q0_32 ._content_a50q0_55 {
  display: flex;
  flex-direction: row;
}
._item_a50q0_32 ._content_a50q0_55 ._text_a50q0_59 {
  font-size: 14px;
  color: #000000;
  flex-grow: 1;
  max-width: calc(100% - 95px);
  margin-right: 18px;
  word-wrap: break-word;
}
._item_a50q0_32 ._content_a50q0_55 ._text_a50q0_59 ._diagnose_a50q0_67 {
  font-size: 14px;
  color: #000000;
}
._item_a50q0_32 ._content_a50q0_55 ._text_a50q0_59 ._diagnose_a50q0_67 span {
  color: #9ea0a5;
}
._item_a50q0_32 ._content_a50q0_55 ._text_a50q0_59 ._mainContent_a50q0_74 {
  margin-top: 10px;
}
._item_a50q0_32 ._content_a50q0_55 ._text_a50q0_59 ._careClaims_a50q0_77 {
  margin-top: 8px;
  font-size: 14px;
  color: #000000;
  display: flex;
}
._item_a50q0_32 ._content_a50q0_55 ._text_a50q0_59 ._careClaims_a50q0_77 ._careClaimsLabel_a50q0_83 {
  color: #9ea0a5;
  margin-right: 3px;
}
._item_a50q0_32 ._content_a50q0_55 ._controls_a50q0_87 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding-right: 24px;
}
._item_a50q0_32 ._content_a50q0_55 ._controls_a50q0_87 ._print_a50q0_93 {
  width: 20px;
  height: 20px;
  border-radius: 100%;
  background: #1665d8 url("/dist/icons/v2/print-solid.svg") no-repeat center;
  background-size: 50%;
  cursor: pointer;
}
._item_a50q0_32 ._content_a50q0_55 ._controls_a50q0_87 ._print_a50q0_93:hover {
  background: #062a60 url("/dist/icons/v2/print-solid.svg") no-repeat center;
}
._item_a50q0_32 ._content_a50q0_55 ._controls_a50q0_87 ._history_a50q0_104 {
  width: 20px;
  height: 20px;
  border-radius: 100%;
  background: #1665d8 url("/dist/icons/v2/clock-rotate-left-regular.svg") no-repeat center;
  background-size: 50%;
  cursor: pointer;
}
._item_a50q0_32 ._content_a50q0_55 ._controls_a50q0_87 ._history_a50q0_104:hover {
  background: #062a60 url("/dist/icons/v2/clock-rotate-left-regular.svg") no-repeat center;
  background-size: 50%;
}
._item_a50q0_32 ._content_a50q0_55 ._controls_a50q0_87 ._edit_a50q0_26 {
  width: 20px;
  height: 20px;
  border-radius: 100%;
  background: #1665d8 url("/dist/icons/v2/pen-edit.svg") no-repeat center;
  background-size: 50%;
  cursor: pointer;
}
._item_a50q0_32 ._content_a50q0_55 ._controls_a50q0_87 ._edit_a50q0_26:hover {
  background: #062a60 url("/dist/icons/v2/pen-edit.svg") no-repeat center;
}
._item_a50q0_32 ._attachment_a50q0_127 ._link_a50q0_127 {
  font-size: 14px;
  color: #1665d8;
  text-decoration: underline;
  cursor: pointer;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  